import { useSelector, useDispatch } from 'react-redux';
import { post, put } from './http';
import * as gtmService from './Gtm.service';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { translate } from './translation';
import { load as loadAccessories } from '../Actions/Accessory.action';
const toastError = (message) => toast.error(message);

export const add = async ({ articleNumber, quantity = 1 }) => {
  if (!quantity || isNaN(quantity) || parseFloat(quantity) <= 0) {
    throw 'Invalid quantity';
  }

  const response = await post('/api/cart/add', {
    articleNumber,
    quantity: parseFloat(quantity),
  }).catch(() => {
    toastError(translate('stockbalance-maximum-amount'));
  });
  const json = await response.json();

  // The added product
  const product = json.orderRows.find((p) => p.articleNumber == articleNumber);
  try {
    if (product && product.gtmProduct) {
      product.gtmProduct.quantity = parseInt(quantity);
      gtmService.pushEcommerce({
        event: 'productImpressions',
        ecommerce: {
          currencyCode: gtmService.getCurrency(),
          add: {
            products: [product.gtmProduct],
          },
        },
      });
      gtmService.dataLayerAddToCart(json.gtmViewModel.ecommerce);
    }
  } catch (error) {
    console.log('error', error);
  }

  return json;
};

export const reorder = async (orderId) => {
  const response = await post('/api/cart/reorder', { orderId });
  return response.json();
};

export const updateQuantity = async (
  articleNumber,
  quantity,
  abortController
) => {
  const productToChange = window.__litium.preloadState.cart.orderRows.find(
    (r) => r.articleNumber == articleNumber
  );

  if (productToChange && quantity == 0) {
    gtmService.dataLayerRemoveFromCart([productToChange.gtmItem]);
  }

  const res = await put(`/api/cart/update`, { articleNumber, quantity }).catch(
    () => {
      toastError(translate('stockbalance-maximum-amount'));
    }
  );
  const cart = await res.json();

  let decreaseQuantity = quantity - productToChange.quantity <= 0;

  productToChange.gtmProduct.quantity = Math.abs(quantity);

  let addRemoveObj = {};

  addRemoveObj[decreaseQuantity ? 'remove' : 'add'] = {
    products: [productToChange.gtmProduct],
  };

  try {
    gtmService.pushEcommerce({
      event: 'productImpressions',
      ecommerce: {
        currencyCode: gtmService.getCurrency(),
        ...addRemoveObj,
      },
    });
  } catch (error) {
    console.log(error);
  }

  return cart;
};
